var enquire = require('enquire.js');

var subNavigationClass = 'sub-navigation'
var listSubVisibleClass = 'sub-navigation__list-sub--visible'
var itemTopActiveClass = 'sub-navigation__item-top--active'
var iconPlusClass = 'sub-navigation__icon-plus'
var iconMinusClass = 'sub-navigation__icon-minus'
var buttonIconTopClass = 'sub-navigation__button-icon--top'
var buttonIconClass = 'sub-navigation__button-icon'
var itemTopClass = 'sub-navigation__item-top'
var linkSubActiveClass = 'sub-navigation__link-sub--active'
var iconTopPlusClass = 'sub-navigation__button-title-icon-plus'
var iconTopMinusClass = 'sub-navigation__button-title-icon-minus'

var helper = require('../helpers/outsideClick.js');

function showTopList(topButton, topPlusIcon, topMinusIcon, topList) {
    topButton.setAttribute('aria-expanded', 'true')
    topPlusIcon.classList.add('hidden')
    topMinusIcon.classList.remove('hidden')
    topList.classList.remove('hidden')
    topList.setAttribute('aria-hidden', 'false') 
}

function hideTopList(topButton, topPlusIcon, topMinusIcon, topList) {
    topButton.setAttribute('aria-expanded', 'false')
    topPlusIcon.classList.remove('hidden')
    topMinusIcon.classList.add('hidden')
    topList.classList.add('hidden')
    topList.setAttribute('aria-hidden', 'true')
}

function showSubList(subButton, plusIcon, minusIcon, subList, subListItem) {
    subButton.setAttribute('aria-expanded', 'true')
    plusIcon.classList.add('hidden')
    minusIcon.classList.remove('hidden')
    subList.classList.add(listSubVisibleClass) 
    subList.setAttribute('aria-hidden', 'false')

    if (subListItem) { subListItem.classList.add(itemTopActiveClass) }
}

function hideSubList(subButton, plusIcon, minusIcon, subList, subListItem) {
    subButton.setAttribute('aria-expanded', 'false') 
    plusIcon.classList.remove('hidden')
    minusIcon.classList.add('hidden')
    subList.classList.remove(listSubVisibleClass)
    subList.setAttribute('aria-hidden', 'true')

    if (subListItem) { subListItem.classList.remove(itemTopActiveClass) }      
}

function hideOrshowSubList() {
    var subButton = this
    var plusIcon = subButton.getElementsByClassName(iconPlusClass)[0]
    var minusIcon = subButton.getElementsByClassName(iconMinusClass)[0]
    var subList = subButton.closest('div').nextElementSibling
    var subListItem

    if (subButton.classList.contains(buttonIconTopClass)) {
         subListItem = subButton.closest('li')
    } else subListItem = null

    if (subList.classList.contains(listSubVisibleClass)) {
        hideSubList(subButton, plusIcon, minusIcon, subList, subListItem)
    } else {
        showSubList(subButton, plusIcon, minusIcon, subList, subListItem)
    }
}

function getLists(element, selector) {
    var lists = []
    for ( ; element; element = element.parentElement) {
            if (element.matches(selector)) {
                lists.push(element)
            }
    }
    return lists
}

function handleActiveLink(lists) {
    for (i = 0; i < (lists.length - 1); i++) {
        var list = lists[i]
        var button = list.previousElementSibling.getElementsByClassName(buttonIconClass)[0]
        var plusIcon = button.getElementsByClassName(iconPlusClass)[0]
        var minusIcon = button.getElementsByClassName(iconMinusClass)[0]
        var listItem
        
        if (list.previousElementSibling.parentElement.classList.contains(itemTopClass)) {
            listItem = list.previousElementSibling.parentElement
        } else listItem = null

        showSubList(button, plusIcon, minusIcon, list, listItem)
    }
}

function initClickOutside(topButton, topPlusIcon, topMinusIcon, topList) {
    document.addEventListener('click', function (event) {
        var isOutside = helper.outsideClick('.sub-navigation', event);
        if (isOutside) hideTopList(topButton, topPlusIcon, topMinusIcon, topList)
    });
}

(function () {
	'use strict';

    var subNavigation = document.getElementsByClassName(subNavigationClass)[0]

    if (!subNavigation) return false

    var topButton = document.querySelector('[data-button-title]')
    var iconButtons = document.querySelectorAll('[data-button-icon]')
    var activeLink = document.getElementsByClassName(linkSubActiveClass)[0]
    var lists = getLists(activeLink, 'ul')

    handleActiveLink(lists)

    enquire.register('screen and (max-width:1023px)', {
        match: function () {
            var topButton = document.querySelector('[data-button-title]')
            var topPlusIcon = topButton.getElementsByClassName(iconTopPlusClass)[0]
            var topMinusIcon = topButton.getElementsByClassName(iconTopMinusClass)[0]
            var topList = topButton.nextElementSibling.nextElementSibling
            
            hideTopList(topButton, topPlusIcon, topMinusIcon, topList)
            initClickOutside(topButton, topPlusIcon, topMinusIcon, topList)
        }
    });

    topButton.addEventListener('click', function() {
        var topButton = this
        var topPlusIcon = topButton.getElementsByClassName(iconTopPlusClass)[0]
        var topMinusIcon = topButton.getElementsByClassName(iconTopMinusClass)[0]
        var topList = topButton.nextElementSibling.nextElementSibling
        var attribute = topList.getAttribute('aria-hidden')

        if (attribute === 'true')  {
            showTopList(topButton, topPlusIcon, topMinusIcon, topList)
        } else {
            hideTopList(topButton, topPlusIcon, topMinusIcon, topList)
        }
    })

    iconButtons.forEach(function(iconButton) {
		  iconButton.addEventListener('click', hideOrshowSubList)
	  })
    
})();